__turbopack_context__.v({
  "disclaimer": "ValuationForm-module-scss-module__u3DSPa__disclaimer",
  "fade-in": "ValuationForm-module-scss-module__u3DSPa__fade-in",
  "no-transform": "ValuationForm-module-scss-module__u3DSPa__no-transform",
  "rotate": "ValuationForm-module-scss-module__u3DSPa__rotate",
});
